"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = require("bignumber.js");
class Report {
    constructor(data) {
        this.data = data;
    }
    get oracle() {
        return this.data.oracle.id;
    }
    get provider() {
        return this.data.provider.id;
    }
    get purged() {
        return this.data.purged;
    }
    get nonce() {
        return new bignumber_js_1.BigNumber(this.data.nonce);
    }
    get report() {
        return new bignumber_js_1.BigNumber(this.data.report);
    }
    get timestamp() {
        return new bignumber_js_1.BigNumber(this.data.timestamp);
    }
    isActiveAt(timestamp, delay, expiry) {
        const ts = new bignumber_js_1.BigNumber(timestamp);
        const reportActive = this.timestamp.plus(delay);
        const reportExpiry = this.timestamp.plus(expiry);
        return !this.purged && ts.gt(reportActive) && ts.lte(reportExpiry);
    }
    static cmpTimestamp(a, b) {
        if (a.timestamp < b.timestamp) {
            return -1;
        }
        if (a.timestamp > b.timestamp) {
            return 1;
        }
        return 0;
    }
    static cmpReport(a, b) {
        if (a.report.lt(b.report)) {
            return -1;
        }
        if (a.report.gt(b.report)) {
            return 1;
        }
        return 0;
    }
    static median(reports) {
        const validReports = reports.filter((r) => r !== null);
        const l = validReports.length;
        if (l == 0) {
            return null;
        }
        else if (l == 1) {
            return validReports[0].report;
        }
        const reports_ = validReports.sort(Report.cmpReport);
        if (l % 2 == 1) {
            return reports_[Math.floor(l / 2)].report;
        }
        return reports_[l / 2 - 1].report.plus(reports_[l / 2].report).div(2);
    }
}
exports.default = Report;
//# sourceMappingURL=Report.js.map